import { boxShadow, color } from '@upstox/upstox-ui';
import { fonts } from '@upstox/upstox-ui/theme/light/fonts';

export const modalContainer: CSSFunction = () => ({
  position: 'absolute',
  height: '100%',
  width: '100%',
  justifyContent: 'center',
  fontFamily: fonts.tvFont,
});

export const modal: CSSFunction = ({ theme }) => ({
  zIndex: 2,
  background: color(theme, theme.modals.backgroundBackdrop),
  height: '100%',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
});

export const base: CSSFunction = ({ theme }) => ({
  zIndex: 3,
  backgroundColor: color(theme, theme.colors.background.default4),
  boxShadow: boxShadow(theme, theme.modals.boxShadow),
  margin: 'auto',
  maxHeight: '100%',
  width: '420px',
  overflow: 'hidden',
  position: 'absolute',
  lineHeight: '20px',
  borderRadius: '4px',
  // borderLeft: cssProps?.showLeftBorder ? `4px solid ${theme.colors.interactive.primary.default}` : 'none',
  flexDirection: 'column',
  justifyContent: 'space-between',
});

export const header: CSSFunction = ({ theme }) => ({
  padding: '16px',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexGrow: 0,
  borderBottom: `1px solid ${color(theme, theme.colors.ui3)}`,
});

export const title: CSSFunction = ({ theme }) => ({
  fontWeight: theme.fontWeights.semiBold,
  fontSize: '20px',
  color: color(theme, 'text.1'),
});

export const closeIcon: CSSFunction = ({ theme }) => ({
  cursor: 'pointer',
  height: '24px',
  width: '24px',
  color: color(theme, 'icon1'),
});

export const modalBody: CSSFunction = () => ({
  padding: '16px',
  width: '100%',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: '20px',
});

export const modalContent: CSSFunction = () => ({
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: '20px',
});

export const convertText: CSSFunction = ({ theme }) => ({
  fontWeight: theme.fontWeights.semiBold,
  fontSize: '16px',
  color: color(theme, 'text.1'),
});

export const inputFieldsContainer: CSSFunction = () => ({
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: '8px',
});

export const inputContainer: CSSFunction = () => ({
  width: '310px',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const inputLabel: CSSFunction = ({ theme }) => ({
  fontSize: '14px',
  color: color(theme, 'text.1'),
  lineHeight: '18px',
});

export const inputField: CSSFunction = () => ({
  width: '135px',
  flexDirection: 'row',
});

export const modalFooter: CSSFunction = ({ theme }) => ({
  width: '100%',
  justifyContent: 'flex-end',
  paddingTop: '16px',
  borderTop: `1px solid ${color(theme, theme.colors.ui3)}`,
});

export const buttonsContainer: CSSFunction = () => ({
  alignItems: 'center',
  gap: '8px',
});

export const button: CSSFunction = ({ theme }) => ({
  border: `1px solid ${color(theme, 'interactive.primary.default')}`,
  borderRadius: '4px',
  color: color(theme, 'interactive.primary.default'),
  cursor: 'pointer',
  fontSize: theme.fontSizes.s,
  fontWeight: theme.fontWeights.normal,
  lineHeight: '20px',
  padding: '8px 16px',
});

export const convertButton: CSSFunction = ({ cssProps, theme }) => ({
  borderRadius: '4px',
  backgroundColor: cssProps.disabled
    ? color(theme, 'disabled.3')
    : color(theme, 'interactive.primary.default'),
  color: color(theme, 'text.3'),
  cursor: 'pointer',
  fontSize: theme.fontSizes.s,
  fontWeight: theme.fontWeights.normal,
  lineHeight: '20px',
  padding: '8px 16px',
});
